import { debounce } from 'lodash';

/**
 * @type {JQuery<HTMLElement>}
 */
var $backToTop;

/**
 * @type {JQuery<HTMLElement>}
 */
var $root;

/**
 * @type {JQuery<HTMLElement>}
 */
var $menus;

export function init (el) {
  $backToTop = $(el);
  $root = $('html, body');
  $menus = $('.navbar-default .dropdown');

  _bindEvents();
}

function _bindEvents () {
  $backToTop.on('click', _scrollToTop);
  $menus.on('shown.bs.dropdown', _scrollToMenu);
  $(window).on('scroll', debounce(_toggleButton, 400));
}

/**
 * @param {JQuery.ClickEvent} e
 */
function _scrollToTop (e) {
  e.preventDefault();
  _scroll(0, 'slow');
}

/**
 * @param {JQuery.TriggeredEvent} e
 */
function _scrollToMenu (e) {
  if($(window).width() < 480) {
    _scroll($(e.target).offset().top);
  }
}

function _toggleButton () {
  if($(window).scrollTop() > 100) {
    $backToTop.fadeIn();
  } else {
    $backToTop.fadeOut();
  }
}

/**
 * @param {number} distance
 * @param {string | number} easing
 */
function _scroll (distance, easing = 400) {
  $root.animate({ scrollTop: distance }, easing);
}
